var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_2",
    d: "M0.503906 12.2174C0.510964 11.9703 0.560369 11.7445 0.65212 11.5398C0.743871 11.3351 0.885027 11.1375 1.07559 10.947L11.6834 0.677883C11.9869 0.374399 12.361 0.222656 12.8056 0.222656C13.1021 0.222656 13.3702 0.293234 13.6102 0.43439C13.8572 0.575546 14.0513 0.766106 14.1925 1.00607C14.3407 1.24604 14.4148 1.51423 14.4148 1.81066C14.4148 2.24824 14.2489 2.63289 13.9172 2.96461L4.3257 12.2068L13.9172 21.4595C14.2489 21.7983 14.4148 22.183 14.4148 22.6135C14.4148 22.917 14.3407 23.1887 14.1925 23.4287C14.0513 23.6686 13.8572 23.8592 13.6102 24.0003C13.3702 24.1485 13.1021 24.2227 12.8056 24.2227C12.361 24.2227 11.9869 24.0674 11.6834 23.7568L1.07559 13.4878C0.877969 13.2972 0.733284 13.0996 0.641533 12.8949C0.549782 12.6832 0.503906 12.4573 0.503906 12.2174Z",
    fill: "currentcolor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.20240103067ac023730427070dd6ab21.svg";
export { ForwardRef as ReactComponent };